var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuteConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 14.381,
    viewBox: "0 0 17.5 14.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Volume",
    transform: "translate(-597.221 -701.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "volume-high-outline",
    d: "M51,99.692H48.308A.308.308,0,0,0,48,100v4.308a.308.308,0,0,0,.308.308h2.679a.613.613,0,0,1,.39.136l3.518,2.88a.308.308,0,0,0,.49-.247V96.923a.308.308,0,0,0-.49-.247l-3.518,2.88A.577.577,0,0,1,51,99.692Zm7.462,4.923a5.456,5.456,0,0,0,.615-2.462,5.316,5.316,0,0,0-.615-2.462m1.846,6.769a7.846,7.846,0,0,0,1.231-4.308,7.715,7.715,0,0,0-1.231-4.308m1.846,10.462a11.179,11.179,0,0,0,0-12.308",
    transform: "translate(549.971 606.923)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteConversationIcon);
export default __webpack_public_path__ + "static/media/unmute-conversation-icon.c8b81f7c4f348104e20b31e7ca9e0ca8.svg";
export { ForwardRef as ReactComponent };